module.exports = __webpack_public_path__ + "img/BF7051_994C2D_E99A7B_DE8C74-256px.f9a9dfad.png";